/* eslint-disable react/prefer-stateless-function */
/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

export default class UnauthenticateRoute extends React.Component {
  render() {
    const {
      courseId, authenticated, role,
      callbackUrl, logout,
      component: Component, ...rest
    } = this.props;

    if (authenticated && callbackUrl && callbackUrl.startsWith('https://clever.com')) {
      window.location.replace(callbackUrl);
      return;
    }

    const path = window.location.pathname
    const isResetPassword = path.indexOf("password-reset") > -1
    if(authenticated && isResetPassword){
      logout(path)
    }
    return (
      <Route
        {...rest}
        render={(props) => {
          if (!authenticated) {
            return <Component {...props} authenticated />;
          }

          const toObj = {
            pathname: callbackUrl || '/dashboard/course',
          };

          return <Redirect to={toObj} />;
        }}
      />
    );
  }
}

UnauthenticateRoute.propTypes = {
  authenticated: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.any,
  courseId: PropTypes.number,
  role: PropTypes.string,
  callbackUrl: PropTypes.string,
};

UnauthenticateRoute.defaultProps = {
  component: () => null,
  role: null,
};
